export default "__VITE_ASSET__CrkMvIQw__"